import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";

// Header & new sections
import Header from "./Components/Header";
import Testimonials from "./Components/Testimonials";
import Steps from "./Components/Steps";
import Pricing from "./Components/Pricing";

import Chatbot from "./Chatbot";
import AddWebsite from "./AddWebsite";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";

axios.defaults.withCredentials = true;
axios
  .get(`${BACKEND_URL}/api/chatbot/config`)
  .catch((err) => console.warn("Config load failed:", err));

function App() {
  const [userId, setUserId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [websiteDomain, setWebsiteDomain] = useState("");
  const [scrapedUrls, setScrapedUrls] = useState([]);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/chatbot/init`)
      .then((res) => {
        if (res.data.success) {
          setUserId(res.data.user_id);
          setSessionId(res.data.session_id);
          setWebsiteDomain(
            res.data.domain && res.data.domain !== "unknown"
              ? res.data.domain
              : ""
          );
        }
      })
      .catch((err) => console.error("Init error:", err));
  }, []);

  const handleWebsiteAdded = (
    domainProcessed,
    urls = [],
    statusType = "finish"
  ) => {
    setWebsiteDomain(
      statusType === "finish" && typeof domainProcessed === "string"
        ? domainProcessed.trim()
        : ""
    );
    setScrapedUrls(urls || []);
  };

  useEffect(() => {
    if (!websiteDomain) return;
    axios
      .get(`${BACKEND_URL}/api/chatbot/scraped_urls`, {
        params: { domain: websiteDomain }
      })
      .then(res => {
        if (res.data.success) {
          setScrapedUrls(res.data.urls);
        }
      })
      .catch(console.error);
  }, [websiteDomain]);

  return (
    <div className="App">
      <Header />

      <section className="App-intro">
        <h1>Welcome to DarkNode AI Chatbot Demo</h1>
        <p>
          Our AI-powered assistant is here to help your visitors instantly find
          information, answer FAQs, and guide them through your site. Simply
          enter your domain and have a demo assistant in under 1 minute.
        </p>
      </section>

      <section className="AddWebsite-section">
        <AddWebsite onWebsiteAdded={handleWebsiteAdded} />
      </section>

      <section className="Chatbot-section">
        <Chatbot
          websiteDomain={websiteDomain}
          sessionId={sessionId}
          userId={userId}
        />
      </section>

      {scrapedUrls.length > 0 && (
        <section className="ScrapedUrls-section">
          <h2>Processed URLs</h2>
          <ul className="ScrapedUrls-list">
            {scrapedUrls.map((url, idx) => (
              <li key={idx}>
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {url}
                </a>
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* <Testimonials /> */}
      <Steps />

      <footer className="App-footer">
        <p>&copy; 2025 DarkNode. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;